(function () {
  'use strict';

  const SECTION_ID = 'product-resources-json';

  const labels = {
    scheda_tecnica: {
      label: 'Scheda Tecnica',
      sublabel: 'Technical Sheet',
      icon: 'file',
    },
    scheda_tecnica_con_scatola: {
      label: 'Scheda Tecnica',
      sublabel: 'Technical Sheet',
      icon: 'file',
    },
    esploso_componenti: {
      label: 'Esploso componenti di produzione',
      sublabel: 'Production exploded view',
      icon: 'file',
    },
    istruzioni_montaggio: {
      label: 'Istruzioni di Installazione',
      sublabel: 'Installation Instructions',
      icon: 'file',
    },
    file_3d: {
      label: 'DWG / 3D Model',
      sublabel: '',
      icon: '3d',
    },
  };

  const variantTags = {
    tradizionale: {
      label: 'Incasso tradizionale',
      sublabel: 'Traditional rough-in',
    },
    scatola: {
      label: 'Incasso con scatola',
      sublabel: 'Rough-in with box',
    },
  };

  function fileIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>';
  }

  function icon3d() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>';
  }

  function getHandle() {
    const params = new URLSearchParams(window.location.search);
    return params.get('p') || '';
  }

  function getVariant() {
    const params = new URLSearchParams(window.location.search);
    const v = (params.get('v') || '').toLowerCase().trim();
    if (v === 'scatola') return 'scatola';
    if (v === 'tradizionale') return 'tradizionale';
    if (params.has('var')) return 'scatola';
    return 'tradizionale';
  }

  function hasVariantParam() {
    const params = new URLSearchParams(window.location.search);
    return params.has('v') || params.has('var');
  }

  function show(id) {
    const el = document.getElementById(id);
    if (el) el.style.display = '';
  }

  function hide(id) {
    const el = document.getElementById(id);
    if (el) el.style.display = 'none';
  }

  async function fetchProductResources(handle) {
    const url = '/products/' + encodeURIComponent(handle) + '?sections=' + SECTION_ID;
    const resp = await fetch(url);
    if (!resp.ok) throw new Error('Product not found');
    const sections = await resp.json();
    var raw = sections[SECTION_ID];
    if (!raw) throw new Error('Section not found');
    var match = raw.match(/>\s*(\{[\s\S]*\})\s*<\//);
    if (match) raw = match[1];
    return JSON.parse(raw);
  }

  async function fetchProductBasicInfo(handle) {
    const resp = await fetch('/products/' + encodeURIComponent(handle) + '.js');
    if (!resp.ok) return null;
    return resp.json();
  }

  // Pick the technical-sheet key for the requested variant.
  // Strict: with ?v=scatola we ONLY accept scheda_tecnica_con_scatola; with default/tradizionale ONLY scheda_tecnica.
  function pickTechSheetKey(resources, variant) {
    if (variant === 'scatola') {
      return resources.scheda_tecnica_con_scatola ? 'scheda_tecnica_con_scatola' : null;
    }
    return resources.scheda_tecnica ? 'scheda_tecnica' : null;
  }

  function arrowIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="M13 5l7 7-7 7"/></svg>';
  }

  function appendButton(container, key, url, opts) {
    const options = opts || {};
    const meta = labels[key] || { label: options.label || key, sublabel: options.sublabel || '', icon: options.icon || 'file' };
    let iconHtml;
    if (options.icon === 'arrow' || meta.icon === 'arrow') iconHtml = arrowIcon();
    else if (meta.icon === '3d') iconHtml = icon3d();
    else iconHtml = fileIcon();

    const a = document.createElement('a');
    a.href = url;
    if (!options.sameTab) {
      a.target = '_blank';
      a.rel = 'noopener';
    }
    a.className = 'qrcode-linktree__btn';

    var inner = iconHtml + '<span class="qrcode-linktree__btn-text"><span class="qrcode-linktree__btn-label">' + meta.label + '</span>';
    if (meta.sublabel) {
      inner += '<span class="qrcode-linktree__btn-sublabel">' + meta.sublabel + '</span>';
    }
    inner += '</span>';
    a.innerHTML = inner;
    container.appendChild(a);
    return a;
  }

  function renderButtons(resources, container, variant, hasDualSheets) {
    let count = 0;

    const techKey = pickTechSheetKey(resources, variant);
    if (techKey) {
      appendButton(container, techKey, resources[techKey]);
      count++;
    } else if (hasDualSheets) {
      // Edge case: this product has dual sheets but the requested one is missing.
      const warn = document.createElement('p');
      warn.className = 'qrcode-linktree__variant-missing';
      const tag = variantTags[variant] || variantTags.tradizionale;
      warn.textContent = 'Scheda tecnica per ' + tag.label.toLowerCase() + ' non disponibile.';
      container.appendChild(warn);
    }

    if (resources.esploso_componenti) {
      // data-esploso-link: intercettato da assets/esploso-warning.js, che mostra
      // l'avvertenza prima di aprire il PDF. appendButton restituisce l'<a>.
      appendButton(container, 'esploso_componenti', resources.esploso_componenti)
        .setAttribute('data-esploso-link', '');
      count++;
    }

    if (resources.istruzioni_montaggio) {
      appendButton(container, 'istruzioni_montaggio', resources.istruzioni_montaggio);
      count++;
    }
    if (resources.file_3d) {
      appendButton(container, 'file_3d', resources.file_3d);
      count++;
    }

    return count;
  }

  function appendProductButton(container, productUrl) {
    appendButton(container, 'product_link', productUrl, {
      label: 'Vedi prodotto',
      sublabel: 'View product',
      icon: 'arrow',
      sameTab: true,
    });
  }

  function renderVariantTag(variant) {
    const meta = variantTags[variant];
    if (!meta) return;
    const slot = document.getElementById('qrcode-variant-slot');
    if (!slot) return;
    const tag = document.createElement('div');
    tag.className = 'qrcode-linktree__variant-tag qrcode-linktree__variant-tag--' + variant;
    tag.innerHTML = '<span class="qrcode-linktree__variant-tag-label">' + meta.label + '</span>' +
      (meta.sublabel ? '<span class="qrcode-linktree__variant-tag-sublabel">' + meta.sublabel + '</span>' : '');
    slot.appendChild(tag);
  }

  function renderCollection(data) {
    const el = document.getElementById('qrcode-collection');
    if (!el) return;
    if (!data || !data.collection_title) return;
    el.textContent = data.collection_title;
    if (data.collection_url) {
      el.setAttribute('href', data.collection_url);
    } else if (data.collection_handle) {
      el.setAttribute('href', '/collections/' + encodeURIComponent(data.collection_handle));
    } else {
      el.removeAttribute('href');
    }
    el.style.display = '';
  }

  async function init() {
    var handle = getHandle();
    if (!handle) {
      hide('qrcode-loading');
      show('qrcode-error');
      return;
    }

    const variant = getVariant();
    const hasExplicitVariant = hasVariantParam();

    try {
      var results = await Promise.all([
        fetchProductResources(handle),
        fetchProductBasicInfo(handle),
      ]);

      var data = results[0];
      var basicInfo = results[1];

      hide('qrcode-loading');

      var productUrl = '/products/' + encodeURIComponent(handle);
      var hasDualSheets = !!(data.resources && data.resources.scheda_tecnica && data.resources.scheda_tecnica_con_scatola);

      // No resources at all: show the no-files state.
      if (!data.has_resources) {
        var titleNoFiles = document.getElementById('qrcode-title-nofiles');
        if (titleNoFiles) titleNoFiles.textContent = data.title || handle;
        var linkNoFiles = document.getElementById('qrcode-product-link-nofiles');
        if (linkNoFiles) linkNoFiles.href = productUrl;
        show('qrcode-no-files');
        return;
      }

      var titleEl = document.getElementById('qrcode-title');
      if (titleEl) titleEl.textContent = data.title || handle;

      renderCollection(data);

      // Show the variant tag only when the product actually has dual sheets (or the URL explicitly specified a variant).
      if (hasDualSheets || hasExplicitVariant) {
        renderVariantTag(variant);
      }

      if (basicInfo && basicInfo.featured_image) {
        var imgContainer = document.getElementById('qrcode-product-image');
        if (imgContainer) {
          var img = document.createElement('img');
          img.src = basicInfo.featured_image;
          img.alt = data.title || '';
          img.loading = 'eager';
          imgContainer.appendChild(img);
        }
      }

      var buttonsContainer = document.getElementById('qrcode-buttons');
      if (buttonsContainer) {
        renderButtons(data.resources, buttonsContainer, variant, hasDualSheets);
        appendProductButton(buttonsContainer, productUrl);
      }

      show('qrcode-content');
    } catch (e) {
      hide('qrcode-loading');
      show('qrcode-error');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
